import { rankWith, isDateTimeControl } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputControlComponent } from 'src/components/JsonForm/controls/InputControl';
import { useEvent } from 'src/hooks/useEvent';

export function DateTimeControlComponent(props: ControlProps) {
    const showPicker = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
        e.target.showPicker();
    });
    return <InputControlComponent {...props} type="datetime-local" onFocus={showPicker} />;
}

export const DateTimeControlTester = rankWith(
    5, //increase rank as needed
    isDateTimeControl,
);

export const DateTimeControl = withJsonFormsControlProps(DateTimeControlComponent);
